import * as React from 'react';
import { Paragraph2 } from '@cian/ui-kit/typography';
import { Button } from '@cian/ui-kit/button';
import * as styles from './RequestDemandSuccess.css';

interface IRequestDemandSuccessProps {
  onReturn(): void;
}

export const RequestDemandSuccess: React.FC<IRequestDemandSuccessProps> = ({ onReturn }) => {
  return (
    <div>
      <Paragraph2>Скоро с вами свяжется риелтор, с которым вы сможете начать работу</Paragraph2>
      <div className={styles['success_action']}>
        <Button size="XS" onClick={onReturn}>
          Вернуться к объявлению
        </Button>
      </div>
    </div>
  );
};

RequestDemandSuccess.displayName = 'RequestDemandSuccess';
